/*
 * @Author: Chao Yang
 * @Date: 2020-08-05 02:00:48
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-08-13 00:44:16
 */
import { InjectionToken } from '@angular/core';

export const DATE_PICKER_CONFIG_DATA = new InjectionToken<{ format: String }>(
    'DATE_PICKER_CONFIG_DATA'
  );